import React from "react";
import Layout from "../../layout/layout";
import SEO from "../../components/SEO";

const QRPayments = () => {
	return (
		<>
			<SEO
				title="QR Payments - Otto Africa"
				description="Learn about Otto Africa's QR code payment solutions. Accept payments quickly and securely using QR codes for your business."
				keywords="QR payments, QR code payments, QR code, payment solutions, Otto Africa QR"
				url="https://ottoafrica.com/about/qr-payments"
			/>
			<Layout />
		</>
	);
};

export default QRPayments;
